import React, { useState, useEffect } from 'react'

interface SearchBarProps {
  placeholder?: string
  value?: string
  onSearch?: (value: string) => void
  onSubmit?: (value: string) => void
  onClick?: () => void
  height?: number
  /** 모바일 키보드 엔터키 라벨 (완료, 검색 등) */
  enterKeyHint?: React.HTMLAttributes<HTMLInputElement>['enterKeyHint']
  /** 코치마크 등에서 이 검색바를 대상으로 지정할 때 (data-tutorial 값) */
  dataTutorial?: string
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = '찾으시는 매장을 입력해주세요',
  value: controlledValue,
  onSearch,
  onSubmit,
  onClick,
  height = 44,
  enterKeyHint,
  dataTutorial,
}) => {
  const [internalValue, setInternalValue] = useState('')
  const isControlled = controlledValue !== undefined
  const searchValue = isControlled ? controlledValue : internalValue

  useEffect(() => {
    if (isControlled) {
      setInternalValue(controlledValue ?? '')
    }
  }, [controlledValue, isControlled])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    if (!isControlled) {
      setInternalValue(newValue)
    }
    if (onSearch) {
      onSearch(newValue)
    }
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (onSubmit) {
      onSubmit(searchValue)
    } else if (onSearch) {
      onSearch(searchValue)
    }
  }

  return (
    <div
      className="w-full flex"
      style={{ height: `${height}px` }}
      data-tutorial={dataTutorial}
    >
      <div className="w-full h-full flex">
        <form
          onSubmit={handleSubmit}
          className={`
            w-full h-full
            relative
            flex
          `}
        >
          <input
            type="text"
            enterKeyHint={enterKeyHint}
            value={searchValue}
            onChange={handleChange}
            onClick={onClick}
            placeholder={placeholder}
            className={`
              w-full h-full
              pl-46px pr-16px
              rounded-12px
              border
              border-brandPrimary-10%
              outline-none
              text-style-body1 text-brown-80%-main
              placeholder:text-brown-80%-main
              cursor-pointer
            `}
            style={{
              boxShadow: '0px 4px 10px 0px rgba(117, 76, 0, 0.1)',
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
            }}
            readOnly={!!onClick}
          />
          <div
            className={`
            absolute left-12px top-1/2 transform -translate-y-1/2
            cursor-pointer
          `}
          >
            <img
              src="/images/search-icon.png"
              alt="검색"
              className="w-24px h-24px object-contain"
            />
          </div>
        </form>
      </div>
    </div>
  )
}

export default SearchBar
